import { ValueObject } from 'ddd-base';
import { Message } from '@/constants';

export class LoginId extends ValueObject<{ value: string }> {
    public static readonly RULES = [(value: string) => value.length <= 254 || '254文字以内で入力してください。'];

    get value() {
        return this.props.value;
    }

    get isValid() {
        return !LoginId.RULES.some((rule) => rule(this.value) !== true);
    }

    get validationMessage() {
        if (!this.value) {
            return Message.NOT_INPUT_ERROR;
        }

        const result = LoginId.RULES.find((rule) => rule(this.value) !== true);
        if (result) {
            return result(this.value) as string;
        }

        return '';
    }
}
